module.exports = __webpack_public_path__ + "static/img/jd-banner.33e8a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/jd-banner.png
// module id = C9bd
// module chunks = 215